import { useAtom, useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { type BrandingPreviewData, brandingPreviewAtom } from '$business/atoms/branding-preview';

export function useBrandingPreviewAtom() {
  const [brandingPreview, setBrandingPreview] = useAtom(brandingPreviewAtom);

  const onBrandingPreviewChange = useCallback((data: BrandingPreviewData) => {
    setBrandingPreview(data);
  }, [setBrandingPreview]);

  return { brandingPreview, onBrandingPreviewChange };
}

export function useROBrandingPreviewAtom() {
  return useAtomValue(brandingPreviewAtom);
}
